import { MutableRefObject, useEffect } from 'react';

export const useClickOutside = ({
  ref,
  refs,
  callback
}: {
  ref?: MutableRefObject<HTMLDivElement | null>;
  refs?: MutableRefObject<HTMLDivElement | null>[];
  callback: () => void;
}) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      let outside = true;

      if (refs) {
        for (const ref of refs) {
          if (ref.current && ref.current.contains(event.target as HTMLDivElement)) {
            outside = false;
          }
        }
      }

      if (ref) {
        if (ref.current && ref.current.contains(event.target as HTMLDivElement)) {
          outside = false;
        }
      }

      if (outside) {
        return callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refs]);
};
